/* eslint-disable @typescript-eslint/no-explicit-any */
import { post } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';
import {
  DocumentValueType,
  MemberPhoneType,
  AttachmentType,
} from '../Types/CommonTypes';

export type AccountIssueRequestType = {
  memberNumber?: string;
  document?: DocumentValueType;
  name: string;
  email: string;
  phoneList: MemberPhoneType[];
  attachment?: AttachmentType[];
};

const definitions = Definitions.AccountIssue;

const callPost = async (
  params: AccountIssueRequestType,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    body: {
      ...params,
    },
  };
  return post(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { post: callPost };
export default { call, definitions };
